<template>
  <div class="myassets-job-queue-button">
    <v-badge
      :content="count"
      :model-value="count > 0"
      color="primary"
      overlap
    >
      <v-btn
        icon
        size="small"
        variant="outlined"
        rounded="circle"
        :color="count > 0 ? 'primary' : 'grey'"
        :title="tooltip"
        @click="openModal"
      >
        <v-icon size="small">fas fa-list-ul</v-icon>
      </v-btn>
    </v-badge>

    <my-assets-jobs-modal
      v-if="showModal"
      ref="jobsModal"
      :category="category"
      @close_modal="closeModal"
    />
  </div>
</template>

<script>
import MyAssetsJobsModal from '@/components/myassets/MyAssetsJobsModal.vue';

export default {
  name: 'MyAssetsJobQueueButton',
  components: { MyAssetsJobsModal },
  props: {
    category: {
      type: String,
      required: true,
      validator: (value) => ['run_model', 'llm'].includes(value),
    },
  },
  data() {
    return {
      showModal: false,
    };
  },
  computed: {
    tooltip() {
      return this.category === 'run_model'
        ? this.$t('myassets.jobs.run_model_title')
        : this.$t('myassets.jobs.llm_title');
    },
    count() {
      return this.category === 'run_model'
        ? this.$store.getters['project_live_jobs/run_model_count']
        : this.$store.getters['project_live_jobs/llm_count'];
    },
  },
  async mounted() {
    if (this.category === 'run_model') {
      await this.$store.dispatch('model/all');
    }
    await this.$store.dispatch('project_live_jobs/ensure_subscribed');
  },
  methods: {
    openModal() {
      this.showModal = true;
    },
    closeModal() {
      this.showModal = false;
    },
  },
};
</script>

<style scoped>
.myassets-job-queue-button {
  display: inline-flex;
  flex-shrink: 0;
  margin-left: 2px;
  padding-right: 10px;
}
</style>
